import * as React from 'react';

import './Modal.scss';
import i18n from 'src/translation/i18n';

interface IModalProps {
  handleCloseModal: () => void;
  showClose?: boolean;
  styles?: object;
  getScrollElement?: (el: HTMLElement) => void;
}

class Modal extends React.Component<IModalProps, any> {
  public componentDidMount = () => {
    const el = document.getElementById('returns_modal_container');
    if (this.props.getScrollElement) {
      this.props.getScrollElement(el);
    }
  };

  public render() {
    return (
      <div className="rp-modal">
        <div
          className="rp-modal-background"
          onClick={e => this.props.handleCloseModal()}
        >
          {this.props.showClose ? (
            <label className="close-modal">
              {(i18n.t('common.close') as string).toUpperCase()}{' '}
              <span
                onClick={e => this.props.handleCloseModal()}
                className="rpds-close close-modal-icon"
              />
            </label>
          ) : null}
        </div>
        <div
          className="rp-modal-container"
          style={this.props.styles}
          id="returns_modal_container"
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Modal;
